import React, { Component } from 'react';

import { isEqual } from 'lodash';
import infoIcon from '../../../images/icons/info.svg';
import { getClass } from '../../../utils/component-helpers';
import megatableService from './megatable-service';

import StatRow from './flagged-stat-row';
import TotalRow from './total-row';
import Tooltip from '../../misc/tooltip';
import SmartlinkModal from '../../publisher/smartlinks/smartlink-editor-modal';

import './stat-table.scss';
import './merch-ed-overview.scss';

class StatTable extends Component {
  constructor(props) {
    super(props);

    this.service = megatableService;
    this.graphClasses = ['green', 'purple', 'orange'];

    this.state = {
      showModal: false,
      smartlinkId: null,
      shadows: {
        left: false,
        right: false,
      },
    };
  }

  addTooltip(el, columnObj) {
    const tooltipText = columnObj.tooltip;
    if (el && tooltipText) {
      new Tooltip(el, { text: tooltipText, size: columnObj.tooltipSize });
    }
  }

  getHeadersHtml() {
    const getSortIcon = columnObj => {
      if (this.props.statType === 'top-article') {
        return ['event_date', 'clicks', 'merchant_revenue'].includes(columnObj.name) ? (
          <div className="caret-container">
            <span
              className={`
								narrativ-icon caret-down
								${this.props.sortOptions.order_by === columnObj.name ? 'selected' : ''}
							`}
              onClick={() => {
                this.props.updateSortParams(columnObj.name, columnObj.label);
              }}
            />
          </div>
        ) : null;
      }
      const sortedColumn =
        columnObj.name !== 'revenue_range'
          ? this.props.sortOptions.order_by === columnObj.name
          : this.props.sortOptions.order_by === 'total_attributed_revenue';
      return sortedColumn ? (
        <span
          className={`narrativ-icon
						${this.props.sortOptions.direction === 'desc' ? 'caret-down' : 'caret-up'}`}
        ></span>
      ) : null;
    };
    const getInfoIcon = columnName => {
      return columnName === 'pricing_model' ? (
        <img src={infoIcon} alt="Info" className="info" />
      ) : null;
    };
    const getLabel = columnObj => {
      return this.service.breadcrumbs.length > 0 && columnObj.name === 'product_name'
        ? 'Product Purchased With'
        : columnObj.label;
    };

    const addShadow = ['merch-ed-overview', 'merchant-performance-overview'].includes(
      this.props.statType,
    );

    return (
      <div className="headers-row">
        {this.props.columns.map((columnObj, index) => {
          if (!columnObj.selected || columnObj.exclude) return null;

          // Strategy performance tabs send graphKey, need checkAll button
          const filled = this.props.graphedRows && this.props.graphedRows.length;
          const checkBoxAll =
            this.props.graphKey && index === 0 ? (
              <div
                className={`checkbox-all ${filled ? 'fill' : ''}`}
                onClick={() => this.props.clearGraphedState()}
              />
            ) : null;

          const sortDisabled =
            this.props.sortDisabledFields.includes(columnObj.name) || columnObj.sortDisabled;
          return this.props.statType === 'top-article' ? (
            <div
              key={index}
              className={getClass(`column ${columnObj.name}`, {
                disabled: sortDisabled,
              })}
            >
              <p
                className={getClass({
                  first: index === 0,
                  [columnObj.class]: columnObj.class,
                })}
              >
                {getLabel(columnObj)}
                {getInfoIcon(columnObj.name)}
              </p>
              {getSortIcon(columnObj)}
            </div>
          ) : (
            <div
              key={index}
              className={getClass(`column ${columnObj.name}`, {
                disabled: sortDisabled,
                'no-shadow': addShadow && !this.state.shadows.left,
              })}
              onClick={() => {
                this.props.updateSortParams(columnObj.name, columnObj.label);
              }}
            >
              {checkBoxAll}
              <p
                ref={node => this.addTooltip(node, columnObj)}
                className={getClass({
                  first: index === 0,
                  [columnObj.class]: columnObj.class,
                })}
              >
                {getLabel(columnObj)}
                {getInfoIcon(columnObj.name)}
              </p>
              {getSortIcon(columnObj)}
            </div>
          );
        })}
      </div>
    );
  }

  mapStatRows(stats, graphed = false) {
    const updateGraphedState = (row, add) => {
      if (!this.props.graphedRows) return;
      this.props.updateGraphedState(row, add);
    };
    const { graphedRows } = this.props;
    const checkboxClass =
      graphedRows && graphedRows.length === this.props.maxGraphedRows ? 'disabled' : '';

    return stats.map((stat, index) => {
      return (
        <StatRow
          key={this.props.statType === 'merch-ed-overview' && 'key' in stat ? stat.key : index}
          data={stat}
          columns={this.props.columns}
          statType={this.props.statType}
          tableName={this.props.tableName}
          disableEditUrl={this.props.disableEditUrl}
          history={this.props.history}
          match={this.props.match}
          location={this.props.location}
          graphed={graphed}
          checkboxClass={graphed ? this.graphClasses[index] : checkboxClass}
          hidden={graphed ? false : this.rowIsHidden(stat)}
          updateGraphedState={row => updateGraphedState(row, !graphed)}
          updateBudget={this.props.updateBudget ? this.props.updateBudget.bind(this) : null}
          toggleModal={this.toggleModal.bind(this)}
          expandedRowId={this.props.expandedRowId}
          budgetRowId={this.props.budgetRowId}
          setRowId={this.props.setRowId}
          shadows={this.state.shadows}
          updateRoiReconSelections={this.props.updateRoiReconSelections}
          roiReconSelections={this.props.roiReconSelections}
          columnFormatter={this.props.columnFormatter}
          setStrategyCrumb={this.props.setStrategyCrumb}
        ></StatRow>
      );
    });
  }

  rowIsHidden(stat) {
    if (!this.props.graphedRows) return;
    const key = this.props.graphKey || 'edit_id';
    return this.props.graphedRows.some(row => row[key] === stat[key]);
  }

  toggleModal(smartlinkId = null) {
    this.setState({
      showModal: !this.state.showModal,
      smartlinkId,
    });
  }

  onTableScroll = event => {
    const { scrollLeft, clientWidth, scrollWidth } = event.target;
    const shadows = { ...this.state.shadows };

    if (!scrollLeft) {
      shadows.left = false;
    } else if (scrollWidth === scrollLeft + clientWidth) {
      shadows.right = false;
    } else {
      shadows.left = true;
      shadows.right = true;
    }

    if (!isEqual(this.state.shadows, shadows)) {
      this.setState({ shadows });
    }
  };

  render() {
    const graphedRows = this.props.showGraphedRows
      ? this.mapStatRows(this.props.graphedRows, true)
      : null;
    const stats = this.mapStatRows(this.props.stats);

    const totalRow = !['product', 'merchantArticleSearch', 'merch-ed-overview'].includes(
      this.props.statType,
    ) ? (
      <TotalRow
        columns={this.props.columns}
        data={this.props.totals}
        statType={this.props.statType}
        showTotals={this.props.showTotals}
        location={this.props.location}
        shadows={this.state.shadows}
      />
    ) : null;

    const modal =
      this.state.showModal && this.state.smartlinkId ? (
        <SmartlinkModal
          smartlinkId={this.state.smartlinkId}
          toggleModal={this.toggleModal.bind(this)}
        ></SmartlinkModal>
      ) : null;

    const isMerchEd = this.props.statType === 'merch-ed-overview';
    const isMerchOverview = this.props.statType === 'merchant-performance-overview';
    const addShadow = isMerchEd || isMerchOverview;

    const className =
      this.props.classOverride ||
      `table ${this.props.statType.toLowerCase()}${isMerchEd ? '' : 's'}`;

    const scrollShadow = addShadow ? (
      <div className={`scroll-shadow ${this.state.shadows.right ? '' : 'no-shadow'}`}></div>
    ) : null;

    return (
      <div className="table-container">
        <div onScroll={this.onTableScroll} className={className}>
          {this.getHeadersHtml()}
          {totalRow}
          {graphedRows}
          {stats}
          {modal}
        </div>
        {scrollShadow}
      </div>
    );
  }
}

export default StatTable;
